"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { normalizeSingleFilterFormData } from "@/helpers/request-helpers";
import { ICampaign } from "@/interfaces/campaign.interface";
import campaignService from "@/services/campaign.service";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetCampaignsReturn = RequestsBaseReturn<PaginatedResponse<ICampaign> | null>;

export interface Props extends RequestPagination {
  filters: IFilter<ICampaign>[];
}

type GetAllSwrParams = [string, number, number, IFilter<ICampaign>[]];

const useGetCampaigns = ({ pageNumber, pageSize, filters }: Props): UseGetCampaignsReturn => {
  const normalizedFilter = normalizeSingleFilterFormData(filters, "name");

  const fetcher = useSWR<PaginatedResponse<ICampaign>, Error, GetAllSwrParams>(
    [SWR_KEYS.getCampaigns, pageNumber, pageSize, normalizedFilter],
    ([, _pageNumber, _pageSize, _filters]) =>
      campaignService.filter(_filters, { pageNumber: _pageNumber, pageSize: _pageSize }),
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetCampaigns;
